/**
 * @file: EnvironmentConfig.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 统一环境配置
 */
import request from '@/utils/request'

/**
 * 环境配置-删除(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function ecDelete(data) {
  return request({
    type: 'biz',
    url: 'ec/delete',
    method: 'post',
    data
  })
}

/**
 * 环境配置-获取详情(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function ecGet(data) {
  return request({
    type: 'biz',
    url: 'ec/get',
    method: 'post',
    data
  })
}

/**
 * 环境配置-新增(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function ecInsert(data) {
  return request({
    type: 'biz',
    url: 'ec/insert',
    method: 'post',
    data
  })
}

/**
 * 环境配置-分页查询(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function ecPageList(data) {
  return request({
    type: 'biz',
    url: 'ec/page/list',
    method: 'post',
    data
  })
}

/**
 * 环境配置-更新(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function ecUpdate(data) {
  return request({
    type: 'biz',
    url: 'ec/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/EnvironmentConfig.js